import { render, staticRenderFns } from "./SolicitudModificacionCalificacionLayout.vue?vue&type=template&id=528cc07b&scoped=true"
import script from "./SolicitudModificacionCalificacionLayout.vue?vue&type=script&lang=js"
export * from "./SolicitudModificacionCalificacionLayout.vue?vue&type=script&lang=js"
import style0 from "./SolicitudModificacionCalificacionLayout.vue?vue&type=style&index=0&id=528cc07b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528cc07b",
  null
  
)

export default component.exports